import gsap from "gsap";

/**
 * Explodes the SVG logo with id 'sitelogo' using GSAP animation matching footer style.
 * Logo slides in assembled (Sky from bottom, Zero from top), then scatters apart with smooth easing.
 */
export function explodeLogo() {
  const logo = document.getElementById("sitelogo");
  if (!(logo instanceof SVGSVGElement)) return;

  const groupSky = logo.querySelector("#logo-Sky") as SVGGElement | null;
  const groupZero = logo.querySelector("#logo-Zero") as SVGGElement | null;

  gsap.set(logo, { height: "auto", display: "block" });
  gsap.set(groupSky, { y: "110%" });
  gsap.set(groupZero, { y: "-110%" });

  // Slide in the logo groups
  gsap.to(groupSky, {
    y: "0%",
    duration: 0.5,
    delay: 0.5,
    ease: "power1.out",
  });
  gsap.to(groupZero, {
    y: "0%",
    duration: 0.5,
    delay: 0.5,
    ease: "power1.out",
    onComplete: () => {
      // Wait a moment, then scatter the paths
      gsap.set(logo, { overflow: "visible" });
      setTimeout(() => scatterPaths(logo), 500);
    },
  });
}

function scatterPaths(logo: SVGSVGElement) {
  const paths = Array.from(logo.querySelectorAll<SVGPathElement>("path"));

  paths.forEach((path) => {
    // Random scatter positions - matching footer style but in reverse
    const randomX = (Math.random() - 0.5) * 150; // -75 to 75
    const randomY = -Math.random() * 200; // 0 to -200 (upward scatter)
    const randomRotate = (Math.random() - 0.5) * 180; // -90 to 90 degrees
    const randomScale = 0.5 + Math.random() * 0.3; // 0.5 to 0.8

    // Animate from assembled (current position) to scattered state
    gsap.to(path, {
      x: randomX,
      y: randomY,
      rotation: randomRotate,
      scale: randomScale,
      opacity: 0, // fade out as it scatters
      duration: 1,
      ease: "power2.out", // smooth easing like footer
      stagger: 0.03, // tighter stagger for smoother feel
      transformOrigin: "center center",
    });
  });
}
